import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, ChevronDown, X } from "lucide-react";

// Optional, per-page plain-language card. Sits UNDER the page; never replaces the book text.
export const PlainWordsCard = ({ card }) => {
  const [open, setOpen] = useState(false);
  if (!card) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-24 z-[41] mx-auto w-[calc(100%-1.5rem)] max-w-md safe-x" data-testid="plain-words-card">
      <AnimatePresence initial={false}>
        {open ? (
          <motion.div
            key="open"
            initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 16 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="pointer-events-auto rounded-2xl bg-ivory-50 p-5 shadow-[0_24px_60px_-30px_rgba(60,46,30,0.55)] ring-1 ring-gold/30"
          >
            <div className="flex items-start justify-between">
              <p className="inline-flex items-center gap-2 font-display text-sm text-gold-deep">
                <Sparkles strokeWidth={1.6} className="h-4 w-4" /> Plain words
              </p>
              <button type="button" onClick={() => setOpen(false)} aria-label="Close" data-testid="plain-words-close"
                className="rounded-full p-1 text-ink-muted hover:text-ink">
                <X strokeWidth={1.8} className="h-4 w-4" />
              </button>
            </div>
            <p className="mt-2 text-sm leading-relaxed text-ink">{card.plain}</p>
            {card.example && (
              <p className="mt-3 rounded-xl bg-ivory-200/70 p-3 text-sm leading-relaxed text-ink-soft">
                <span className="font-display text-gold-deep">For example — </span>{card.example}
              </p>
            )}
            <p className="mt-3 text-[11px] text-ink-muted">A plain-language companion to the page above. The author's words stay exactly as written.</p>
          </motion.div>
        ) : (
          <motion.button
            key="pill"
            type="button"
            onClick={() => setOpen(true)}
            data-testid="plain-words-open"
            initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 12 }}
            className="debossed-btn pointer-events-auto mx-auto flex items-center gap-2 rounded-full px-5 py-2.5 font-display text-sm text-ink"
          >
            <Sparkles strokeWidth={1.6} className="h-4 w-4 text-gold-deep" /> Plain words for this page
            <ChevronDown strokeWidth={1.8} className="h-4 w-4 text-ink-muted" />
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};
